import type { ShopBrandDealsModule } from 'types/capi/modules';

import Image, { smallImageOptions } from '~/components/Image';
import Tracked from '~/components/Tracked';

type Props = { module: ShopBrandDealsModule };

export default function ShopBrandDeals({ module }: Props) {
  return (
    <div className="relative">
      <div className="min-w-full">
        <BackgroundImage module={module} />
        <Content module={module} />
      </div>
    </div>
  );
}

function BackgroundImage({ module }: Props) {
  return (
    <Image
      alt="shop-brand-deals-image"
      src={module.background_image.url}
      className="absolute block size-full object-cover"
      loading="eager"
      responsiveOptions={{ xs: { height: 672, retainRatio: true } }}
    />
  );
}

function Content({ module }: Props) {
  return (
    <div className="flex w-full justify-center py-12 md:py-16">
      <div className="relative mx-4 flex max-w-3xl flex-col items-center gap-6 overflow-hidden bg-grey-tile/90 px-7 py-8 md:px-12">
        <Header module={module} />
        <BrandImages module={module} />
        <Cta module={module} />
      </div>
    </div>
  );
}

function Header({ module }: Props) {
  return (
    <h2 className="text-[32px] leading-10 md:text-[40px]">{module.header}</h2>
  );
}

function BrandImages({ module }: Props) {
  return (
    <div className="flex gap-2">
      {module.items.map((item) => (
        <div key={item.alt} className="size-10 rounded bg-white p-1 sm:size-12">
          <Image
            src={item.url}
            alt={item.alt}
            {...smallImageOptions({ pad: true })}
          />
        </div>
      ))}
    </div>
  );
}

function Cta({ module }: Props) {
  return (
    <div className="w-full max-w-72">
      <Tracked.InternalLink
        variant="forest"
        className="flex h-12 items-center justify-center"
        pagePosition="Homepage Popular Brands"
        name="VIEW_ALL"
        to={module.cta.path}
      >
        {module.cta.text}
      </Tracked.InternalLink>
    </div>
  );
}
